import { IBudgetServices } from './budget.types';
import { http } from '@/shared/https';
import { AppTransformers as transform } from '@/shared/transform';

export class BudgetService implements IBudgetServices {

    importFile(file: any, transactionId: any, schema: any, context: string = "") {
        let formData = new FormData();
        formData.append("file", file);

        return http.post(`api/Budget/Import/${transactionId}/${context}`, formData, 'multipart/form-data')
            .then((resp: any) => {
                if (resp.data.Result === 'OK') {
                    var data = resp.data.Record;
                    return { Result: 'OK', Record: data, documentId: resp.data.DocumentId, Validation: resp.data.Validation, Mismatches: resp.data.IncorrectCells }
                } else {
                    return resp.data;
                }
            });
    }

    // download template
    generateTemplate(id: any, filename: string, context: string = "") {
        http.getFile(`api/Budget/Download/${id}/${context}`, 'application/vnd.ms-excel')
            .then((resp: any) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${filename || 'Budget'}.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
    }

    exportToExcel(id: any, filename: string, context?: string) {
        http.getFile(`api/Budget/DownloadBudgetExcel/${id}/${context}`, 'application/vnd.ms-excel')
            .then((resp: any) => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${filename || 'Budget'}.xlsx`);
                document.body.appendChild(link);
                link.click();
            });
    }
}